import React from 'react';
import { motion } from 'framer-motion';
import { Search, BarChart3, CalendarCheck } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: Search,
    title: 'Search',
    desc: 'Browse by location, service type, or rating to find your perfect match.'
  }, {
    icon: BarChart3,
    title: 'Compare',
    desc: 'Read verified reviews and compare prices across top-rated spas.'
  }, {
    icon: CalendarCheck,
    title: 'Book',
    desc: 'Book your session with confidence and enjoy your relaxation.'
  }];
  return <section id="how-it-works" className="py-24 bg-forest text-cream relative overflow-hidden" data-id="element-222">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-223">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-224" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-225">
        <div className="text-center mb-20" data-id="element-226">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-227">
            How It Works <span className="text-gold font-light" data-id="element-228">使用流程</span>
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto" data-id="element-229">
            Your journey to relaxation is just three simple steps away.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-230">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-white/10 z-0" data-id="element-231" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center group" data-id="element-232">
              <div className="w-24 h-24 rounded-full bg-forest-light border-4 border-forest shadow-xl flex items-center justify-center mb-8 group-hover:scale-110 group-hover:border-gold transition-all duration-300" data-id="element-233">
                <step.icon size={32} className="text-gold" data-id="element-234" />
              </div>

              <div className="absolute top-0 right-1/2 translate-x-1/2 -translate-y-1/2 bg-forest px-2 text-gold font-serif font-bold text-xl" data-id="element-235">
                0{index + 1}
              </div>

              <h3 className="text-2xl font-serif font-bold text-white mb-3" data-id="element-236">
                {step.title}
              </h3>
              <p className="text-white/60 leading-relaxed max-w-xs" data-id="element-237">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}